import { useState } from 'react';

import { ViewRefModel } from '../../Models/ViewRefModel';
import GenericPropertyInput from './GenericPropertyInput';
import GenericPropertyInputRefContent from './GenericPropertyInputRefContent';
import { ViewInputDialog } from './ViewInputDialog';

type ViewInputProps = {
	viewRef: ViewRefModel | undefined;
	onViewRefChange: (viewRef: ViewRefModel | undefined) => void;
	isEditable?: boolean;
};

export default function ViewInput({ viewRef, onViewRefChange, isEditable = true }: ViewInputProps) {
	const [open, setOpen] = useState(false);

	// In non-edit mode, just show the reference name
	if (!isEditable) {
		return <GenericPropertyInputRefContent value={viewRef} />;
	}

	return (
		<GenericPropertyInput value={viewRef} onValueChange={onViewRefChange} onOpen={() => setOpen(true)}>
			<GenericPropertyInputRefContent value={viewRef} />
			{open && <ViewInputDialog open={open} setOpen={setOpen} viewRef={viewRef} onViewRefChange={onViewRefChange} />}
		</GenericPropertyInput>
	);
}
